<template>
  <section class="content">
    <div class="container-fluid">
      <h2>Profil Warga</h2>

      <div v-if="loading" class="text-muted">Memuat data...</div>

      <div v-else>
        <!-- Profile Card -->
        <div class="card shadow-sm rounded mb-4">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">Ubah Password</h5>
          </div>
          <div class="card-body">

            <!-- Password Lama -->
            <div class="form-group position-relative">
              <label>Password Lama</label>
              <input :type="showOldPassword ? 'text' : 'password'" class="form-control" v-model="oldPassword" />
              <i class="fas fa-eye position-absolute" :class="{ 'fa-eye-slash': showOldPassword }" 
                 style="right: 10px; top: 38px; cursor: pointer; position: absolute;"
                 @click="showOldPassword = !showOldPassword"></i>
            </div>

            <!-- Password Baru -->
            <div class="form-group position-relative">
              <label>Password Baru</label>
              <input :type="showNewPassword ? 'text' : 'password'" class="form-control" v-model="newPassword" />
              <i class="fas fa-eye position-absolute" :class="{ 'fa-eye-slash': showNewPassword }" 
                 style="right: 10px; top: 38px; cursor: pointer; position: absolute;"
                 @click="showNewPassword = !showNewPassword"></i>
            </div>

            <!-- Konfirmasi Password -->
            <div class="form-group position-relative">
              <label>Konfirmasi Password Baru</label>
              <input :type="showConfirmPassword ? 'text' : 'password'" class="form-control" v-model="confirmPassword" />
              <i class="fas fa-eye position-absolute" :class="{ 'fa-eye-slash': showConfirmPassword }" 
                 style="right: 10px; top: 38px; cursor: pointer; position: absolute;"
                 @click="showConfirmPassword = !showConfirmPassword"></i>
            </div>

            <!-- Message -->
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>

            <!-- Button -->
            <button class="btn btn-primary" @click="submit" :disabled="loading">
              <i v-if="loading" class="fas fa-spinner fa-spin"></i> Simpan
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import alert from '@/utils/alert'

const oldPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
const router = useRouter()

// toggle show/hide
const showOldPassword = ref(false)
const showNewPassword = ref(false)
const showConfirmPassword = ref(false)

// ambil dari localStorage
const email = localStorage.getItem('username')
const token = localStorage.getItem('token')

const submit = async () => {
  errorMessage.value = ''
  successMessage.value = ''

  if (!oldPassword.value || !newPassword.value || !confirmPassword.value) {
    errorMessage.value = 'Semua field wajib diisi.'
    return
  }

  if (newPassword.value !== confirmPassword.value) {
    errorMessage.value = 'Konfirmasi password tidak cocok.'
    return
  }

  loading.value = true

  try {
    const res = await axios.post('https://metatekapps.metateknologi.com/api-vms-ubah-password.php', {
      email,
      token,
      old_password: oldPassword.value,
      new_password: newPassword.value
    })

    if (res.data.status === 200) {
    //   successMessage.value = 'Password berhasil diubah.'
    //   oldPassword.value = ''
    //   newPassword.value = ''
    //   confirmPassword.value = ''
      alert.success('Password sukses diubah, silahkan login kembali')
      localStorage.clear()
      sessionStorage.clear()
      router.push('/')
    } else {
      errorMessage.value = res.data.message || 'Gagal mengubah password.'
    }
  } catch (err) {
    errorMessage.value = err.response?.data?.message || 'Terjadi kesalahan.'
  } finally {
    loading.value = false
  }
}
</script>
